module.exports = __webpack_public_path__ + "static/colors-content-nonessential-do-c5bda67792c43bc5fc9fa90deaf57f08.png";